export enum StatusEnum {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
  BLOCKED = 'BLOCKED',
}

export interface AdminCategoryMetricsDTO {
    id: string;
    name: string;
    icon: string;
    activeAdsCount: number;
    conversionRate: number;
    trend: 'UP' | 'DOWN' | 'STABLE';
    status: 'ACTIVE' | 'BLOCKED';
    subcategory?: string[] | null;
    slug?: string| null;
    priority_order?: number;
}
export interface CategoryDTO {
    id?: string;
    name?: string;
    slug?: string;
    icon?: string;
    status?: 'ACTIVE' | 'BLOCKED';
    updatedAt?: string;
}

export interface AdminCategorySearchDTO {
    q?: string;
    status?: 'ACTIVE' | 'BLOCKED';
    page?: number;
    size?: number;
    sort?: string;
    direction?: 'ASC' | 'DESC';
}

export class Category {
  id?: string | null;
  name?: string | null;
  status?: StatusEnum | null;
  slug?: string | null;
  icon?: string | null;
  parent_id?: string | null;
  priority_order?: number | null;
  featured?: boolean | null;
  subcategory?: string[] | null;
  createdAt?: Date | null;
  updatedtedAt?: Date | null;
}

export interface AdminCategorySearchResponseDTO {
    list: AdminCategoryMetricsDTO[];
    totalAmount: number;
}

export interface AggregatedCategoryMetricsDTO {
     totalActiveAds: number,
     totalSubcategories: number
}
